import React, { useState } from 'react';
import { FormGroupLabel } from '../common/FormGroupLabel';
import { acClose, acEye, acEyeOff, acMagnifier } from 'ac-icon';
import Icon from '../../icon/Icon';
import classNames from 'classnames';
import { isEmpty } from 'ac-share';
const Input = ({ id, type, name, label, value, valid, feedback, required, disabled, onChange, placeholder, min, max, step, className, helpText, autoFocus, autoComplete, search, isClear, rightIconPath, onClick, isPassword, onClickIconPassword, onBlur, onFocus, onEnter, onClickRightIcon, feedbackClassName, isShowRequired, }) => {
    const [isShowPassword, setIsShowPassword] = useState(false);
    const renderRightIcon = () => {
        if (isPassword) {
            return (React.createElement("button", { type: 'button', className: 'search-icon is-hover', onClick: (e) => {
                    setIsShowPassword(!isShowPassword);
                    onClickIconPassword(e);
                } },
                React.createElement(Icon, { path: isShowPassword ? acEye : acEyeOff, size: '20px', title: isShowPassword ? 'Скрыть' : 'Показать' })));
        }
        else {
            if ((isClear || search) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                return (React.createElement("button", { type: 'button', className: 'search-icon is-hover', onClick: () => {
                        onChange('');
                    } },
                    React.createElement(Icon, { path: acClose, size: '20px', title: 'Очистить' })));
            }
            else if (search) {
                const cssIcon = classNames('search-icon', {
                    'is-hover': !!(search === null || search === void 0 ? void 0 : search.onClickSearch) || (search === null || search === void 0 ? void 0 : search.buttonType) === 'submit',
                });
                return (React.createElement("button", { id: (search === null || search === void 0 ? void 0 : search.id) ? search.id : 'search-btn', type: (search === null || search === void 0 ? void 0 : search.buttonType) ? search.buttonType : 'button', className: cssIcon, onClick: (search === null || search === void 0 ? void 0 : search.onClickSearch)
                        ? () => {
                            search.onClickSearch();
                        }
                        : undefined },
                    React.createElement(Icon, { id: 'search-' + ((search === null || search === void 0 ? void 0 : search.id) || 'icon'), path: acMagnifier, size: '20px', title: (search === null || search === void 0 ? void 0 : search.title) || 'Поиск' })));
            }
            else if (rightIconPath) {
                const cssIcon = classNames('search-icon', {
                    'is-hover': !!onClickRightIcon,
                });
                return (React.createElement("button", { type: 'button', className: cssIcon, onClick: onClickRightIcon
                        ? () => {
                            onClickRightIcon();
                        }
                        : undefined },
                    React.createElement(Icon, { path: rightIconPath, size: '20px', title: undefined })));
            }
            else {
                return undefined;
            }
        }
    };
    const cssInput = classNames('ac-input', isClear || search || isPassword || rightIconPath ? 'with-icon' : '');
    return (React.createElement(FormGroupLabel, { label: label, valid: valid, feedback: feedback, className: className, isShowRequired: !isEmpty(isShowRequired) ? isShowRequired : required, helpText: helpText, feedbackClassName: feedbackClassName },
        React.createElement("div", { className: 'input-wrapper' },
            React.createElement("input", { onKeyDown: (event) => {
                    if (event.key === 'Enter') {
                        onEnter && onEnter(event);
                    }
                }, id: id, autoComplete: autoComplete ? 'on' : 'off', onClick: onClick, name: name, type: isPassword && isShowPassword ? 'text' : type, value: value || '', required: required, disabled: disabled, className: cssInput, onChange: (evt) => {
                    onChange(evt.target.value);
                }, placeholder: placeholder, min: min, max: max, step: step, autoFocus: autoFocus, onFocus: (e) => {
                    e.stopPropagation();
                    onFocus && onFocus(e);
                }, onBlur: (e) => {
                    e.stopPropagation();
                    onBlur && onBlur(e);
                } }),
            renderRightIcon())));
};
export { Input };
//# sourceMappingURL=Input.js.map